module.exports = __webpack_public_path__ + "img/check.2daf3d75.svg";